import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'previewModal',
    theme => `
		width: 95vw;
		height: 95%;
		padding: 20px;
		box-sizing: border-box;
		overflow: auto;

		& > header {
			border-bottom: 4px solid ${theme.color.text.HB};
			padding-bottom: 20px;
			text-align: center;
		}

		& > main {
			margin-top: 20px;
		}

		& > footer {
			display: flex;
			justify-content: space-between;
			width: 100%;
			max-width: 480px;
			margin: 40px auto 20px auto;
		}
	`
  ],
  [
    'previewItem',
    (theme, [editable]) => `
    border-bottom: 1px solid ${theme.color.text.HB};
		padding: 8px 6px;
		transition: background-color 0.3s ease;
		cursor: ${editable ? 'pointer' : 'not-allowed'};

		&:hover {
			background-color: ${theme.color.text.HB};
		}
	`
  ],
  [
    'previewItemAnswerContainer',
    `
		margin-top: 8px;
		padding-left: 10px;
		min-height: 10px;
	`
  ],
  [
    'action',
    `
		width: 45%;
	`
  ]
]);
